export default __webpack_public_path__ + "static/f3-ef3ad6198ed29a311b85250601f8945c.svg";